import { Observable, of } from 'rxjs';
import { ComponentDataSourceService } from '../component-data-source.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { UserEmailConflictDTO } from '../../../dto/users/user-email-conflict.dto';

export function email_conflicts(
  componentDataSourceService: ComponentDataSourceService,
  http: HttpClient,
  router: Router
) {
    return {
      name: 'Email Konflikter',
      description: 'Liste af email konflikter fra sync processen',
      execute: (params?: LoadDataParams) => {
        
        // Use the new GET approach with query parameters
        return componentDataSourceService['loadDataWithStandardFiltersGET']('email_conflicts', '/users/manage/conflicts', params).pipe(
          catchError(error => {
            console.error('Error fetching conflicts:', error);
            return of({ data: [], meta: { totalItems: 0, page: 1, pageSize: 10 } });
          }),
          map(result => {
            // Handle both response formats
            let items: UserEmailConflictDTO[] = [];
            let totalCount = 0;
            let pageSize = 10;
            let pageIndex = 0;

            if (result && result.data && result.meta) {
              // ListResponseDTO format
              items = result.data;
              totalCount = result.meta.totalItems || 0;
              pageSize = result.meta.pageSize || 10;
              pageIndex = (result.meta.page || 1) - 1;
            } else if (result && result.items) {
              // Legacy format
              items = result.items;
              totalCount = result.totalCount || 0;
              pageSize = result.pageSize || 10;
              pageIndex = result.pageIndex || 0;
            }

            return {
              items: items,
              totalCount: totalCount,
              pageSize: pageSize,
              pageIndex: pageIndex,
              filters: result.filters || null
            };
          })
        );
      },
      settings: {
        columns: [
          { 
            key: 'proposed_email', 
            header: 'Foreslået Email', 
            type: 'text',
            sortable: true
          },
          { 
            key: 'existing_email', 
            header: 'Eksisterende Email', 
            type: 'text',
            transform: (value: string | null) => value || 'N/A',
            sortable: false
          },
          { 
            key: 'mobile', 
            header: 'Mobilnummer', 
            type: 'text',
            transform: (value: string | null) => value || 'Mangler',
            sortable: false
          },
          {
            key: 'conflict_type',
            header: 'Konflikt Type',
            type: 'component',
            componentName: 'badge',
            componentInputs: (row: UserEmailConflictDTO) => {
              // Ensure conflict_type exists
              if (!row.conflict_type) {
                return { text: 'Ukendt', color: 'default' };
              }
              const typeMap: {[key: string]: {text: string; color: string}} = {
                'same_mobile_different_email': { text: 'Samme mobil, forskellig email', color: 'warn' },
                'missing_mobile': { text: 'Mangler mobilnummer', color: 'accent' }
              };
              const config = typeMap[row.conflict_type] || { text: row.conflict_type, color: 'default' };
              return config;
            },
            sortable: true,
            alignment: 'center'
          },
          {
            key: 'actions',
            header: 'Handlinger',
            type: 'button',
            buttonText: 'Løs',
            buttonColor: 'primary',
            alignment: 'right',
            variant: 'raised',
            action: (row: UserEmailConflictDTO) => {
              // Trigger custom event for conflict resolution
              window.dispatchEvent(new CustomEvent('resolve-email-conflict', { detail: row }));
            },
            // Only show button for same_mobile_different_email conflicts
            // missing_mobile conflicts cannot be resolved from this component
            showIf: (row: UserEmailConflictDTO) => row.conflict_type !== 'missing_mobile'
          }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        searchable: true,
        defaultSortColumn: 'created_at',
        defaultSortDirection: 'desc'
      }
    }
}

